import type { ReactNode } from 'react';

type LinkProps = {
  url: string;
  newTab: boolean;
  children: ReactNode;
};

export const Link = ({ url, newTab, children }: LinkProps) => {
  return (
    <a
      className="hover:text-red-30 underline outline-none"
      href={url}
      target={newTab ? '_blank' : '_self'}
      // Security: noopener prevents the target page from accessing window.opener
      // noreferrer prevents passing the referrer header to the target page
      // Both are important for links opening in new tabs to prevent tabnabbing attacks
      rel={newTab ? 'noopener noreferrer' : undefined}
    >
      {children}
    </a>
  );
};
